import React from 'react'
import { useNavigate } from 'react-router-dom'
import AuthenticatedRoutes from '../../Utils/AuthenticatedRoutes'
import './welcome.css'

const Welcome = () => {
  const navigate = useNavigate()
  return (
    <div className='container container_light welcome'>
      <AuthenticatedRoutes />
      <img src='/assets/images/logo.png' alt='' />
      <h1>
        Welcome to
        <br />
        Arrowhead
      </h1>
      <p>
        You’re almost ready to feel the
        <br />
        magic of our
        <br />
        Chat GPT for meetings 🪄
      </p>
      <button onClick={() => navigate('/signin')}>Let&apos;s do it!</button>
    </div>
  )
}

export default Welcome
